import {PropertyHouseAdditionalAreas} from "../../../offer/detail/constants/PropertyHouseAdditionalAreas";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const houseAdditionalAreas: ISearchFilterSlot<"house_additional_areas", string[]> = {
    id: "house_additional_areas",
    label: "Powierzchnie dodatkowe",
    filters: [
        {
            id: "house_additional_areas",
            type: SearchFilterTypes.MULTI_CHECKBOX,
            filterOptions: [
                {id: "house_additional_areas_balcony", value: PropertyHouseAdditionalAreas.BALCONY.toString(), label: "Balkon"},
                {id: "house_additional_areas_terrace", value: PropertyHouseAdditionalAreas.TERRACE.toString(), label: "Taras"},
                {id: "house_additional_areas_garden", value: PropertyHouseAdditionalAreas.GARDEN.toString(), label: "Ogród"},
                {id: "house_additional_areas_garage", value: PropertyHouseAdditionalAreas.GARAGE.toString(), label: "Garaż"},
                {id: "house_additional_areas_attic", value: PropertyHouseAdditionalAreas.ATTIC.toString(), label: "Poddasze"}
            ]
        }
    ]
};
import {PropertyHouseAdditionalAreas} from "../../../offer/detail/constants/PropertyHouseAdditionalAreas";
import {ISearchFilterSlot} from "../../types/ISearchFilters";
import {SearchFilterTypes} from "../../types/SearchFilterTypes";

export const houseAdditionalAreas: ISearchFilterSlot<"house_additional_areas", string[]> = {
    id: "house_additional_areas",
    label: "Powierzchnie dodatkowe",
    filters: [
        {
            id: "house_additional_areas",
            type: SearchFilterTypes.MULTI_CHECKBOX,
            filterOptions: [
                {id: "house_additional_areas_balcony", value: PropertyHouseAdditionalAreas.BALCONY.toString(), label: "Balkon"},
                {id: "house_additional_areas_terrace", value: PropertyHouseAdditionalAreas.TERRACE.toString(), label: "Taras"},
                {id: "house_additional_areas_garden", value: PropertyHouseAdditionalAreas.GARDEN.toString(), label: "Ogród"},
                {id: "house_additional_areas_garage", value: PropertyHouseAdditionalAreas.GARAGE.toString(), label: "Garaż"},
                {id: "house_additional_areas_attic", value: PropertyHouseAdditionalAreas.ATTIC.toString(), label: "Poddasze"}
            ]
        }
    ]
};
